export default __webpack_public_path__ + "assets/apchaLogo.2df099ba.png";